import en from './en-US';
import pt from './pt-BR';

const i18nMessages = {
  ...en,
  ...pt,
};

export default i18nMessages;
